class Common {
 
  setToken (token) {
    sessionStorage.setItem("token", token);
  }

  getToken () {
    return sessionStorage.getItem("token");
  }

  /**
   * 退出登录
   */
  loginOut () {
    sessionStorage.setItem("token", "");
  }
  /**
   * 缓存用户基础信息
   * @param userInfo
   */
  setUserInfo(userInfo) {
    userInfo = JSON.stringify(userInfo);
    sessionStorage.setItem("userInfo", userInfo);
  }
  /**
   * 从缓存中获取用户信息
   * @returns {string}
   */
  getUserInfo() {
    return JSON.parse(sessionStorage.getItem("userInfo"));
  }
  /**
   * 缓存筛选树状json
   * @param TreeChannelJson
   */
  setTreeChannelJson(treeChannelJson) {
    treeChannelJson = JSON.stringify(treeChannelJson);
    sessionStorage.setItem("treeChannelJson", treeChannelJson);
  }

  /**
   * 从缓存中获取用户信息
   * @returns {string}
   */
  getTreeChannelJson() {
    return JSON.parse(sessionStorage.getItem("treeChannelJson"));
  }
  /**
   * 更新缓存中用户信息 的某一个字段
   * @param key1  user|member
   * @param key2
   * @param value
   */
  updateUserInfo(key1, key2, value) {
    var userInfo = this.getUserInfo();
    userInfo[key1][key2] = value;
    this.setUserInfo(userInfo);
  }

  setMemberNameSession(value) {
    sessionStorage.setItem("memberName", value);
  }

  getMemberNameSession() {
    return sessionStorage.getItem("memberName");
  }
}




const common = new Common();

export default common;
